import getActiveDrawerPane from "../selectors/getActiveDrawerPane";
import getTabIdFromWindow from "./getTabIdFromWindow";

/**
 * Checks if a drawer pane is currently active in the specified window.
 * @param targetWindow - The window to check the visibility in. Defaults to the current window.
 * @returns True if a drawer pane is active, false otherwise.
 */
export default function hasActiveDrawerPane(targetWindow?: Window): boolean {
    const tabId = getTabIdFromWindow(targetWindow);
    return getActiveDrawerPane(tabId) !== undefined;
}
